import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";
import { useAuth } from "../../context/AuthContext";
import Modal from "../../components/Modal/Modal";

const API_URL = process.env.REACT_APP_API_URL;
const SITE_URL = process.env.REACT_APP_SITE_URL;

const Navbar = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { logout: authLogout } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();
	const [modalData, setModalData] = useState({
		isVisible: false,
		message: "",
		type: "",
	});

	const adminPathRegex = /^\/admin\/user-management\/activities\/[0-9]+$/;

	const handleBackNavigation = () => {
		if (adminPathRegex.test(location.pathname)) {
			navigate("/admin/user-management");
		} else if (location.pathname === "/user/activities") {
			navigate("/user/dashboard");
		} else if (location.pathname === "/admin/user-management") {
			navigate("/admin/dashboard");
		} else {
			navigate(-1);
		}
	};

	const SignOutWithSSO = async () => {
		try {
			const token = localStorage.getItem("token");

			const logoutResponse = await fetch(
				`${API_URL}/accounts/auth/keycloak/logout`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Token ${token}`,
					},
				}
			);

			if (logoutResponse.ok) {
				const data = await logoutResponse.json();
				if (data.logout_url) {
					authLogout();
					window.location.href = data.logout_url + "&post_logout_redirect_uri=https://cv.kntu.ac.ir/login";
					return;
				}
			}
            
            await SignOut();
            			
		} catch (error) {
			console.error("Error during logout:", error);
			authLogout();
			navigate("/login");
		}
	};

	const SignOut = async () => {
		try {
			const token = localStorage.getItem("token");
			const response = await fetch(`${API_URL}/accounts/logout`, {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Token ${token}`,
				},
			});
		} finally {
			authLogout();
			navigate("/login");
		}
	};

	const navigatePage = () => {
		const role = localStorage.getItem("role");
		role === "admin"
			? navigate("/admin/change-password")
			: navigate("https://sso.kntu.ac.ir/realms/kntu/login-actions/reset-credentials");
	};

	return (
		<div className="navbar-container">
			<nav className="navbar">
				<div className="navbar-wrapper">
					<ul className="navbar-list">
						<li className="navbar-item">
							<div className="profile-navbar-container">
								<div className="profile-border">
									<img
										src="/kntu-logo.png"
										alt="Profile"
										className="profile-image"
										onClick={() => setIsOpen(!isOpen)}
										onError={(e) =>
											(e.target.src = "logo192.png")
										}
									/>
								</div>
								{isOpen && (
									<div className="menu-bar">
										<ul>
											<li onClick={navigatePage}>
												تغییر رمز عبور
											</li>
											<li onClick={SignOutWithSSO}>
												خروج از حساب کاربری
											</li>
										</ul>
									</div>
								)}
							</div>
						</li>
					</ul>
					<ul className="navbar-list">
						<li className="navbar-item">
							<h4 className="navbar-title">
								سامانه مدیریت رزومه دانشگاه صنعتی خواجه
								نصیر‌الدین طوسی
							</h4>
						</li>
						<li className="navbar-item">
							<a href={SITE_URL} className="home-button">
								بازگشت به صفحه اصلی
							</a>
						</li>
					</ul>
				</div>
				{["/admin/dashboard", "/user/dashboard"].includes(
					location.pathname
				) ? (
					<></>
				) : (
					<div className="navbar-wrapper">
						<ul className="navbar-list">
							<li className="navbar-item">
								<button
									className="back-button btn medium-text"
									onClick={() => handleBackNavigation()}
								>
									بازگشت
								</button>
							</li>
						</ul>
					</div>
				)}
			</nav>
			<Modal
				message={modalData.message}
				type={modalData.type}
				isVisible={modalData.isVisible}
				onClose={() => setModalData({ ...modalData, isVisible: false })}
			/>
		</div>
	);
};

export default Navbar;
